// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonNouns = {
  time: "Time",
  operator: "Operator",
  staff: "Exam Staff",
  candidate: "Candidate",
  user: "User",
  paper: "Paper",
  question: "Question",
  exam: "Exam",
  attempt: "Attempt",
  status: "Status",
  role: "Role",
  type: "Type",
  description: "Description",
  codeSnapshot: "Code Snapshot",
  actions: "Actions",
} as const;
